import React, { createContext, useContext } from 'react';

const DashboardBreadcrumbContext = createContext({
  breadcrumb: null,
  setBreadcrumb: () => {},
});

export function DashboardBreadcrumbProvider({ value, children }) {
  return (
    <DashboardBreadcrumbContext.Provider value={value}>
      {children}
    </DashboardBreadcrumbContext.Provider>
  );
}

export function useDashboardBreadcrumb() {
  return useContext(DashboardBreadcrumbContext);
}
